/* OchreLane — "Model info" on product images (snippets/ol-model-info.liquid). Added 3 Nov 2026.
   Opening one box closes any other; a click outside or Esc closes it. */
(function () {
  'use strict';
  if (window.OLModelInfo) return;
  window.OLModelInfo = true;

  function closeAll(except) {
    document.querySelectorAll('details.ol-model-info[open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  // "toggle" doesn't bubble, so listen while it travels down.
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (d.matches && d.matches('details.ol-model-info') && d.open) closeAll(d);
  }, true);

  document.addEventListener('click', function (event) {
    if (!(event.target.closest && event.target.closest('details.ol-model-info'))) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('details.ol-model-info[open]');
    if (!open) return;
    open.removeAttribute('open');
    open.querySelector('summary').focus();
  });
})();
